import { HttpHandler } from 'msw'

import { getAllPermissions } from './getAllPermissions'

export const permissions: HttpHandler[] = [getAllPermissions]
